import {NewTableDef} from 'app/shared/tables/table-column-def';

export class CurrentAssortmentDetailsListModel {
    margin: number;
    productId: number;
    productName: string;
    revenueGross: number;
    unitSalesPrcGross: number;
    ean: number;
    code: number;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CurrentAssortmentDetailsList',
            columns: [
                {columnDef: 'productId'},
                {
                    field: 'productName',
                    columnDef: 'productName',
                    header: 'Nazwa',
                    isGeneralSearchColumn: true
                },
                {
                    field: 'unitSalesPrcGross',
                    columnDef: 'unitSalesPrcGross',
                    header: 'Cena',
                    type: 'currency',
                    suffix: 'currency',
                    showSearch: false,
                    width: 10
                },
                {
                    field: 'revenueGross',
                    columnDef: 'revenueGross',
                    header: 'Przychód',
                    type: 'currency',
                    suffix: 'currency',
                    showSearch: false,
                    width: 10
                },
                {
                    field: 'margin',
                    columnDef: 'margin',
                    header: 'Marża',
                    type: 'margin',
                    showSearch: false,
                    width: 10
                },
                {
                    field: 'ean',
                    columnDef: 'ean',
                    header: 'EAN',
                    showSearch: false,
                    width: 10
                }
            ]
        };
    }
}
